
import React from 'react';
import { UUID } from '../model/fragments'
import { fetchProductRackVendors } from '../api/fetchProductRackVendors';

export const useFetchProductRackVendors = () => {

	return React.useCallback(async (lat: number | undefined, lng: number | undefined, productRackIds: UUID[]) => {

		const response = await fetchProductRackVendors({
			lat,
			lng,
			productRackIds,
		});

		if(!response.ok) {
			return null;
		}

		return response.data.items;
	}, []);
}
